/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Control_Stop_DescInputs */

const en_mk_team_control_stop_desc = /** @type {(inputs: Mk_Team_Control_Stop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve checkpoints to continue. When stopped, Bystep waits for confirmation that processes have ended before releasing the work.`)
};

const id_mk_team_control_stop_desc = /** @type {(inputs: Mk_Team_Control_Stop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui checkpoint untuk lanjut. Saat dihentikan, Bystep menunggu konfirmasi proses berhenti sebelum melepas pekerjaan.`)
};

/**
* | output |
* | --- |
* | "Approve checkpoints to continue. When stopped, Bystep waits for confirmation that processes have ended before releasing the work." |
*
* @param {Mk_Team_Control_Stop_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_control_stop_desc = /** @type {((inputs?: Mk_Team_Control_Stop_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Control_Stop_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_control_stop_desc(inputs)
	return en_mk_team_control_stop_desc(inputs)
});